<template>
  <v-data-table
    :headers="cabeceras"
    :items="filasTabla"
    item-key="uuid"
    dense
    class="elevation-1"
  >
    <template #item.acciones="{ item }">
      <v-btn icon small color="primary" @click="$emit('editar-producto', item)">
        <v-icon style="font-size: 20px">mdi-pencil-outline</v-icon>
      </v-btn>

      <v-btn icon small color="red" @click="$emit('eliminar-producto', item)">
        <v-icon style="font-size: 20px">mdi-delete-outline</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'TablaProductosGrid',

  props: {
    gridConfig: { type: Array, required: true }, // columnas
    productos: { type: Array, required: true },  // filas
  },

  computed: {
    // Construye cabeceras desde grid_config
    cabeceras() {
      const columnasOrdenadas = [...this.gridConfig].sort(
        (a, b) => Number(a.orden) - Number(b.orden)
      )

      const columnas = columnasOrdenadas.map(col => ({
        text: col.nombre,
        value: col.nombre,
        sortable: false,
      }))

      return [
        { text: 'Acciones', value: 'acciones', sortable: false },
        ...columnas,
      ]
    },

    // Construye filas desde productos.params
    filasTabla() {
      return this.productos.map(prod => {
        const fila = { uuid: prod.uuid }

        for (const param of prod.params) {
          fila[param.nombre] = param.displayValue || param.valor?.[0] || ''
        }

        return fila
      })
    },
  },
}
</script>

<style scoped></style>
